import React from 'react';
import "./MailApp.css";
import MailToolbar from "./MailToolbar.mjs";
import appLib from "../../../libs/appLib.mjs";
import Mailbox from "./Mailbox.mjs";
import MailEditor from "./MailEditor/MailEditor.mjs";

const G = window.glob;

const MailApp = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentbox: 'inbox',
			maildata: appLib.mailByPlayer(),
			read:  G.getStatus('PlayerStatus')?.read?.mail
		};
		this.selectBox = this.selectBox.bind(this);
		this.writeNewMail = this.writeNewMail.bind(this);
		this.uid = G.generateUid('MailApp');
	}
	componentDidMount() {
		G.register('NewMailReceived', md => {
			this.setState({maildata: md});
		}, this.uid);
		G.register('UnreadMailCount', c => {
			const r = G.getStatus('PlayerStatus').read?.mail || {};
			this.setState({ read: r });
		}, this.uid);
		G.register('WriteNewMail', maildata => {
			G.trigger('OpenMailEditor', { open: true, message: maildata });
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	selectBox(b) {
		if ( b !== this.state.currentbox ) this.setState({currentbox: b} );
		G.trigger('MessagePreview', { box: b });
	}
	writeNewMail() {

	}
	render() {
		return (
			<div className={"MailApp"} id={this.uid}>
				<MailToolbar
					value={this.state.currentbox}
					onChange={this.selectBox}
				/>
				<div
					className={"AppContainer "+(this.state.currentbox === 'inbox' ? 'active' : 'inactive')}
				>
					<Mailbox
						box={"inbox"}
						data={this.state.maildata?.data?.inbox}
						read={this.state.read}
					/>
				</div>
				<div
					className={"AppContainer "+(this.state.currentbox === 'sent' ? 'active' : 'inactive')}
				>
					<Mailbox
						box={"sent"}
						data={this.state.maildata?.data?.sent}
						read={this.state.read}
					/>
				</div>
				<MailEditor />
			</div>
		);
	}
}

export default MailApp;